// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-material/dist/theme/default.css
// module id = 276
// module chunks = 0